document.addEventListener("DOMContentLoaded", function () {
  // Select all <details> elements representing submenu items
  const submenuDetails = document.querySelectorAll(".menu-drawer__menu details");

  submenuDetails.forEach((details) => {
    details.addEventListener("toggle", function () {
      const icon = this.querySelector('[data-rotation]'); // Find the arrow icon within the toggled <details>
      if (icon) {
        if (this.open) {
          icon.classList.add("flip-vertical"); // Flip the arrow up
        } else {
          icon.classList.remove("flip-vertical"); // Reset the arrow to down
        }
      }
    });
  });
});
